import { supabase } from '../lib/supabase'
import { serviziAttiviSincroni } from '../servizi/ServiziProvider'

/** Il token e firmato e a scadenza: lo emette solo il server, mai il client. */
export async function generaLinkCliente(impiantoId: number): Promise<string> {
  if (!serviziAttiviSincroni().eAttivo('dashboardUtenteFinale')) {
    throw new Error('Attiva il modulo Dashboard utente finale per generare il link')
  }
  const { data, error } = await supabase.functions.invoke('genera-link-cliente', { body: { impiantoId } })
  if (error) throw new Error(error.message)
  return (data as { url: string }).url
}
